/**
 * The recipients' tags (#219): «Enviar DeCA a» on a DeCA and «Destinatarios del DeCA» on a book
 * entry. Pure, so the field, the forms and the send dialog read one rule. The server's
 * (`backend/src/deca/email-recipients.ts`) decides: this only shapes what is sent to it.
 */

/** A DeCA's recipients, at most: the server's `MAX_DECA_RECIPIENTS`. A book entry has no limit. */
export const MAX_DECA_RECIPIENTS = 10

/** Text typed or pasted, as addresses: split on commas, semicolons, spaces and line breaks. */
export function splitAddresses(text: string): string[] {
  return text
    .split(/[,;\s]+/)
    .map((part) => part.trim())
    .filter((part) => part !== '')
}

/**
 * [incoming] added to [current], each once (compared without case, as the server keeps them, the
 * first spelling winning), up to [max] when there is one. An address the server would not take is
 * kept, for the field to mark; what did not fit is returned apart.
 */
export function addAddresses(
  current: readonly string[],
  incoming: readonly string[],
  max?: number,
): { next: string[]; overflow: string[] } {
  const next = [...current]
  const overflow: string[] = []
  const seen = new Set(current.map((address) => address.toLowerCase()))
  for (const address of incoming) {
    const key = address.toLowerCase()
    if (seen.has(key)) continue
    if (max !== undefined && next.length >= max) {
      overflow.push(address)
      continue
    }
    seen.add(key)
    next.push(address)
  }
  return { next, overflow }
}
